import { useCallback, useState } from "react";
import {
  Link,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { BiBadgeCheck, BiXCircle, BiTimeFive } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { VIRTUAL_LOCKER_STATUS_CHANGE } from "../../../actions/admin/customer-actions";

const STATUS_OPTIONS = [
  { value: "active", label: "Active", icon: BiBadgeCheck },
  { value: "inactive", label: "Inactive", icon: BiXCircle },
  { value: "expired", label: "Expired", icon: BiTimeFive },
];

export default function VirtualLockerActions({ id, status, onUpdated }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const activeStatus = String(status || "inactive").toLowerCase();

  const changeLockerStatus = useCallback(
    (nextStatus) => {
      if (!id || nextStatus === activeStatus) return;
      dispatch({
        type: VIRTUAL_LOCKER_STATUS_CHANGE,
        payload: {
          id,
          status: nextStatus,
          onSuccess: () => {
            onUpdated?.();
            setAnchorEl(null);
          },
        },
      });
    },
    [dispatch, id, activeStatus, onUpdated]
  );

  return (
    <>
      <Link
        component="button"
        underline="none"
        color="primary"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        VIEW
      </Link>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          elevation: 3,
          sx: { minWidth: 200, borderRadius: 2, mt: 1 },
        }}
      >
        {STATUS_OPTIONS.map((option) => {
          const Icon = option.icon;
          return (
            <MenuItem
              key={option.value}
              disabled={activeStatus === option.value}
              onClick={() => changeLockerStatus(option.value)}
            >
              <ListItemIcon>
                <Icon size={20} color="error" />
              </ListItemIcon>
              <ListItemText primary={option.label} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
